import IconButton from "./IconButton";
import {IconType} from "./Icons";
import {CSSProperties} from "react";

interface TypedIconButtonProps {
    type: IconType;
    onClick: (data: any) => void;
    data: any;
    style?: CSSProperties;
}

function TypedIconButton(props: TypedIconButtonProps) {
    const {type, data, onClick} = props;

    return <IconButton type={type} onClick={onClick} data={data}/>;
}

export default TypedIconButton;